import React from "react";

export const Eyebrow = ({ children, light }) => (
  <span className={`inline-block font-mono text-xs uppercase tracking-[0.25em] ${light ? "text-gold-light" : "text-gold"}`}>
    {children}
  </span>
);

export const SectionTitle = ({ eyebrow, title, subtitle, light, center, className = "" }) => (
  <div className={`${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"} ${className}`}>
    {eyebrow && <Eyebrow light={light}>{eyebrow}</Eyebrow>}
    <h2 className={`mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight ${light ? "text-white" : "text-navy"}`}>
      {title}
    </h2>
    {subtitle && <p className={`mt-4 text-base leading-relaxed ${light ? "text-white/70" : "text-slate-600"}`}>{subtitle}</p>}
  </div>
);

export const ServiceHero = ({ eyebrow, title, subtitle, image }) => (
  <section className="relative overflow-hidden">
    <div className="absolute inset-0">
      <img src={image} alt="" className="h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-navy/90 via-navy/70 to-navy/40" />
    </div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-24 sm:py-32">
      <div className="max-w-2xl fade-up">
        <Eyebrow light>{eyebrow}</Eyebrow>
        <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight text-shadow-lg">{title}</h1>
        {subtitle && <p className="mt-5 text-lg text-white/85 leading-relaxed">{subtitle}</p>}
      </div>
    </div>
  </section>
);

export const StepList = ({ steps }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    {steps.map((s, i) => (
      <div key={i} className="rounded-xl border border-black/5 bg-white p-7 card-hover" data-testid={`step-${i + 1}`}>
        <span className="font-serif text-4xl font-bold text-gold/40">{String(i + 1).padStart(2, "0")}</span>
        <h3 className="mt-3 font-sans text-lg font-semibold text-navy">{s.title}</h3>
        <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
      </div>
    ))}
  </div>
);

export const FeatureCard = ({ icon: Icon, title, desc }) => (
  <div className="rounded-xl border border-black/5 bg-white p-7 card-hover">
    <span className="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-navy/5 text-gold">
      <Icon className="h-6 w-6" />
    </span>
    <h3 className="mt-4 font-sans text-lg font-semibold text-navy">{title}</h3>
    <p className="mt-2 text-sm text-slate-600 leading-relaxed">{desc}</p>
  </div>
);
